<template>
  <div class="bg-primary-orange">
    <div class="flex justify-between items-center text-gray-800 z-10 px-6 h-24">
      <h1 class="text-3xl font-heading">{{ state == 'login' ? "Log In" : "Sign Up" }}</h1>
    </div>
    <div
      class="flex-1 overflow-y-scroll bg-gray-100 py-6 px-3 rounded-t-xl flex justify-center items-center"
    >
      <div class="text-center">
        <div v-if="state == 'login'">
          <form @submit.prevent="login" class="bg-white rounded-lg p-4 -my-1">
            <input
              name="email"
              autocomplete="email"
              class="w-full p-2 border border-gray-400 rounded-lg my-1"
              type="email"
              placeholder="Email"
              v-model="loginData.email"
            />
            <input
              name="password"
              autocomplete="current-password"
              class="w-full p-2 border border-gray-400 rounded-lg my-1"
              type="password"
              placeholder="*****"
              v-model="loginData.password"
            />
            <button class="w-full bg-primary-orange rounded-lg py-2 mt-4" type="submit">Log In</button>
          </form>
          <div class="flex flex-col">
            <button
              @click="state = 'signup'"
              class="mx-auto text-sm bg-orange-200 py-2 px-4 rounded-lg mt-10"
            >Don't have an account? Sign Up.</button>
            <button
              @click="state = 'passwordReset'"
              class="mx-auto text-sm bg-red-200 py-2 px-4 rounded-lg mt-3"
            >Forgot password?</button>
          </div>
        </div>
        <div v-if="state == 'signup'">
          <form @submit.prevent="signUp" class="bg-white rounded-lg p-4 -my-1">
            <input
              name="email"
              autocomplete="email"
              class="w-full p-2 border border-gray-400 rounded-lg my-1"
              type="email"
              placeholder="Email"
              v-model="signUpData.email"
            />
            <input
              name="password"
              autocomplete="new-password"
              class="w-full p-2 border border-gray-400 rounded-lg my-1"
              type="password"
              placeholder="*****"
              v-model="signUpData.password"
            />
            <button class="w-full bg-primary-orange rounded-lg py-2 mt-4" type="submit">Sign Up</button>
          </form>
          <button
            @click="state = 'login'"
            class="text-sm bg-orange-200 py-2 px-4 rounded-lg mt-10"
          >Sign in with your existing account here.</button>
        </div>
        <div v-if="state == 'passwordReset'">
          <form @submit.prevent="resetPassword" class="bg-white rounded-lg p-4 -my-1">
            <p class="mb-2">Enter your email and we will send a password reset email.</p>
            <input
              class="w-full p-2 border border-gray-400 rounded-lg my-1"
              type="email"
              placeholder="Email"
              v-model="passwordResetEmail"
            />
            <button class="w-full bg-primary-orange rounded-lg py-2 mt-4" type="submit">Send Email</button>
          </form>
          <button
            @click="state = 'login'"
            class="text-sm bg-orange-200 py-2 px-4 rounded-lg mt-10"
          >Sign in with your existing account here.</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notification from "@/components/Notification.vue";

export default {
  name: "login",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Notification
  },
  data() {
    return {
      state: "login",
      loginData: {
        email: "",
        password: ""
      },
      signUpData: {
        email: "",
        password: ""
      },
      passwordResetEmail: ""
    };
  },
  methods: {
    signUp: async function() {
      this.$store.dispatch("setLoading", true);
      try {
        let result = await this.AuthService.signUp(this.signUpData);
        await this.AuthService.sendVerificationEmail();
        if (result) {
          await this.FireService.createSampleRecipe();
          this.$router.replace({ name: "home" });
        }
      } catch (error) {
        this.$store.dispatch("setLoading", false);
        console.error(error);
        this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  type: "danger",
                  close: onClose
                }
              },
              error.message
            );
          },
          {
            position: "bottom"
          }
        );
      }
    },
    login: async function() {
      this.$store.dispatch("setLoading", true);
      try {
        let result = await this.AuthService.login(this.loginData);
        if (result) {
          this.$router.replace({ name: "home" });
        }
      } catch (error) {
        console.error(error);
        this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  type: "danger",
                  close: onClose
                }
              },
              error.code == "auth/wrong-password"
                ? "The password is incorrect."
                : error.message
            );
          },
          {
            position: "bottom"
          }
        );
        this.$store.dispatch("setLoading", false);
      }
    },
    resetPassword: async function() {
      this.$store.dispatch("setLoading", true);
      try {
        await this.AuthService.sendPasswordReset(this.passwordResetEmail);
        this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  close: onClose
                }
              },
              "Password reset email sent."
            );
          },
          {
            position: "bottom"
          }
        );
        this.state = "login";
      } catch (error) {
        console.error(error);
        this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  type: "danger",
                  close: onClose
                }
              },
              error.code == "auth/user-not-found"
                ? "There is no user found for this email address."
                : error.message
            );
          },
          {
            position: "bottom"
          }
        );
      }
      this.$store.dispatch("setLoading", false);
    }
  }
};
</script>